import { BusinessDownloadConfig } from '../types';

const MobileBenchmarkConfig: BusinessDownloadConfig = {
  'mobile-benchmark-kpi_data': {
    apiUrl: '/api/v1/intelligence_pc/topChartMobileBenchmarkMetricsExcel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_source',
        type: 'checkboxGroup',
        field: 'sources',
        defaultValue: ['appannie'],
        options: [
          { label: 'data.ai', value: 'appannie' },
          { label: 'DataBrain', value: 'databrain' },
        ]
      },
      {
        label: 'dbi_label_metrics',
        type: 'checkboxGroup',
        field: 'metrics',
        defaultValue: ['revenue'],
        options: [
          { label: 'dbi_benchmark_revenue_mobile', value: 'revenue' },
          { label: 'dbi_benchmark_download_mobile', value: 'download' },
          { label: 'dbi_benchmark_dau_mobile', value: 'dau' },
        ]
      },
      {
        label: 'dbi_label_basic_info',
        type: 'checkbox',
        field: 'data_sources',
        defaultValue: {
          company_show: false,
          genre_show: false,
          release_date_show: false,
          region_show: false,
        },
        options: [
          { label: 'dbi_label_company_info', value: 'company_show' },
          { label: 'dbi_label_genre', value: 'genre_show' },
          { label: 'dbi_release_date', value: 'release_date_show' },
          { label: 'dbi_area_region', value: 'region_show' },
        ],
      },
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_palyform_Setting',
            type: 'radio',
            field: 'systems',
            defaultValue: 'Both',
            options: [
              { label: 'dbi_benchmark_both', value: 'Both' },
              { label: 'dbi_benchmark_ios', value: 'ios' },
              { label: 'dbi_benchmark_android', value: 'Android' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              // { label: 'dbi_label_separate_by_country', value: 'market' },
              { label: 'dbi_label_separate_by_region', value: 'region' },
            ],
          },
        ],
      },
    ],
  },
  'mobile-benchmark-player_activity': {
    apiUrl: '/api/v1/intelligence_pc/topChartMobileBenchmarkMetricsExcel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_source',
        type: 'checkboxGroup',
        field: 'sources',
        defaultValue: ['appannie'],
        options: [
          { label: 'data.ai', value: 'appannie' },
          { label: 'DataBrain', value: 'databrain' },
        ]
      },
      {
        label: 'dbi_label_basic_info',
        type: 'checkbox',
        field: 'data_sources',
        defaultValue: {
          company_show: false,
          genre_show: false,
          release_date_show: false,
          region_show: false,
        },
        options: [
          { label: 'dbi_label_company_info', value: 'company_show' },
          { label: 'dbi_label_genre', value: 'genre_show' },
          { label: 'dbi_release_date', value: 'release_date_show' },
          { label: 'dbi_area_region', value: 'region_show' },
        ],
      },
      {
        label: 'dbi_label_palyform_Setting',
        type: 'radio',
        field: 'systems',
        defaultValue: 'Both',
        options: [
          { label: 'dbi_benchmark_both', value: 'Both' },
          { label: 'dbi_benchmark_ios', value: 'ios' },
          { label: 'dbi_benchmark_android', value: 'Android' },
        ],
      },
    ],
  },
  'mobile-benchmark-social_channels': {
    apiUrl: '/api/v1/intelligence_pc/topChartMobileBenchmarkMetricsExcel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_benchmark_stream_source',
        type: 'checkboxGroup',
        field: 'steam_source',
        defaultValue: ['youtube'],
        options: [
          {
            label: 'dbi_benchmark_twitch',
            value: 'twitch',
          },
          {
            label: 'dbi_benchmark_youtube',
            value: 'ytg',
          },
          {
            label: 'dbi_benchmark_facebook',
            value: 'facebook',
          },
        ]
      },
      {
        label: 'dbi_benchmark_time_scale',
        type: 'checkboxGroup',
        field: 'time_scale',
        defaultValue: ['lt'],
        options: [
          {
            label: 'dbi_benchmark_lifetime',
            value: 'lt',
          },
          {
            label: 'dbi_benchmark_365d',
            value: '365d',
          },
          {
            label: 'dbi_benchmark_30d',
            value: '30d',
          },
        ]
      },
    ],
  },
  'mobile-benchmark-basic_info': {
    apiUrl: '/api/v1/intelligence_pc/topChartMobileBenchmarkMetricsExcel',
    bubbleText: '',
    translate: true,
    formList: [],
  }
}

export default MobileBenchmarkConfig 